import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card.js';
import { Button } from '@/components/ui/Button.js';
import { StatusDot } from '@/components/ui/StatusDot.js';
import { toast } from 'sonner';

export function StyleGuidePage(): JSX.Element {
  return (
    <div className="space-y-10">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Style guide</h1>
        <p className="text-sm text-muted-foreground">
          Reference for every UI primitive. Plugin authors design against these.
        </p>
      </header>

      <Section title="Buttons" description="Primary, secondary, ghost, outline, destructive.">
        <div className="flex flex-wrap gap-2">
          <Button>Default</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="destructive">Destructive</Button>
          <Button variant="link">Link</Button>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button size="sm">Small</Button>
          <Button>Default size</Button>
          <Button size="lg">Large</Button>
        </div>
      </Section>

      <Section title="Status dots" description="Drive Component cards and tree rollups.">
        <div className="flex gap-6">
          <StatusDot state="up" showLabel />
          <StatusDot state="degraded" showLabel />
          <StatusDot state="down" showLabel />
          <StatusDot state="unknown" showLabel />
        </div>
      </Section>

      <Section title="Toasts" description="Sonner. Top-right, stackable, dismissable.">
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => toast('Default toast')}>Default</Button>
          <Button variant="outline" onClick={() => toast.success('Backup completed')}>Success</Button>
          <Button variant="outline" onClick={() => toast.error('Permission denied: applications.shell')}>Error</Button>
          <Button variant="outline" onClick={() => toast.info('Webhook configured in GitHub')}>Info</Button>
        </div>
      </Section>

      <Section title="Terminal output" description="Script run results, log tails, shell sessions.">
        <pre className="terminal">{`$ uptime
 14:02:11 up 23 days,  4:17,  2 users,  load average: 0.18, 0.12, 0.09
$ systemctl is-active nginx
active`}</pre>
      </Section>
    </div>
  );
}

function Section({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">{children}</CardContent>
    </Card>
  );
}
